<template>
  <v-container id="signatureBackground_root" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pa-2">
          <v-card-title>
            {{ $t('signatureBackground.title') }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <!-- CONTENT -->
    <v-row
      class="mb-4"
    >
      <!-- signatureImageParameters -->
      <drag-drop-upload
        id="upload_image"
        single-image
        :current-imageurl="sourceImageDataUrl"
        :description="$t('dragDrop.imgDescription')"
        max-width="100%"
        :valid-formats="['image/png','image/jpeg']"
        given-height="200px"
        :add-signature-drawer-button="false"
        @uploaded="handleDragDrop"
      ></drag-drop-upload>
    </v-row>
    <v-row
      id="background_color_button"
      class="mb-4"
    >
      <!-- Background Color Picker -->
      <color-picker v-model="backgroundColor" value="hex" button-class="mr-3" icon="mdi-palette" :label="$t('signatureDrawer.backgroundColor')" @input="handleBackroundValueChange"></color-picker>
    </v-row>
    <v-row
      class="mb-4"
    >
      <v-col cols="6">
        <div>
          <canvas id="preview" ref="canvas" width="600" height="200"></canvas>
        </div>
      </v-col>
    </v-row>
    <v-row
      class="mb-4"
    >
      <v-btn
        id="save"
        color="primary"
        class="my-4"
        @click="save"
      >
        <v-icon>mdi-content-save-outline</v-icon>
        {{ $t('main.save') }}
      </v-btn>
    </v-row>
    <v-card>
    </v-card>
  </v-container>
</template>
<script>
import ColorPicker from '@/components/ColorPicker.vue'
import DragDropUpload from '@/components/DragDropUpload.vue'
import { fabric } from 'fabric'
import { showConfirmationMenu, showToastError, showToastSuccess } from '../../event-bus'
import signatures from '../../services/api/signatures'

export default {
  components: {
    ColorPicker, DragDropUpload
  },
  data() {
    return {
      defaultCanvasWidth: 600,
      defaultTextHeight: 20,
      defaultCanvasHeight: 200,
      paddingPercent: 0.10,
      userVerificationImage: null,
      sourceImageDataUrl: null,
      fcanvas: null,

      backgroundImageUrl: null,
      backgroundImageFile: {},
      // signatureImage: null,
      backgroundImg: null,
      signatureImageUrl: null,

      signatureImageFile: {},
      // signatureImage: null,
      signatureImg: null,
      paddingX: 0,
      paddingY: 0,
      paddedWidth: 0,
      paddedHeight: 0,
      backgroundColor: '#FFFFFF',
      anottationControls: { mtr: false, mr: false, ml: false, mt: false, mb: false },
      signatureDragHandleColor: '#FBB615',
      imageDataFormat: { format: 'image/png' },
      signatureVerificationImg: null,
      leftBlockWidth: 300,
      imageWidth: 0,
      imageHeight: 0,
      scaledWidth: 0,
      scaledHeight: 0,
      initialImageWidth: 0,
      initialImageHeight: 0,
      rules: {
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        minMax: (v) => (v && v.length <= this.maxCharacters) || this.$t('validation.form.mustBeLessThan', { max: this.maxCharacters })
      }
    }
  },
  computed: {
    useBackgroundColor() {
      return this.backgroundImageUrl === null
    }
  },
  watch: {
    search() {
      this.dataTableLoading = true
      this.searchUserGroupsWatcher()
    },
    pagination: {
      handler() {
        this.searchUserGroups()
      }
    }

  },
  async mounted() {
    window.fabric.Object.prototype.objectCaching = false

    /* this.userVerificationImage = await signatures.getVisibleSignatureUserVerificationImage(this.signatureProfile.id)
    await this.getVerificationImageDimensions(this.userVerificationImage.data.imageDataUrl) */

    const resp = await signatures.getVisisigAdminProps()
    // this.backgroundColor = resp.data.bgColor ? this.getHexColorFromBackendColor(resp.data.bgColor) : '#FFFFFF'
    this.backgroundColor = resp.data.bgColor ? resp.data.bgColor : '#FFFFFF'
    this.backgroundImageUrl = resp.data.bgImageDataUrl ? resp.data.bgImageDataUrl : null
    this.sourceImageDataUrl = resp.data.bgImageDataUrl ? resp.data.bgImageDataUrl : null

    this.userVerificationImage = await signatures.getVisibleSignatureUserVerificationImage()
    await this.getVerificationImageDimensions(this.userVerificationImage.data.imageDataUrl)

    this.signatureVerificationImg = new fabric.Image(this.verificationImg, {
      left: this.leftBlockWidth,
      top: 0,
      originY: 'top',
      originX: 'left',
      transparentCorners: false,
      borderColor: this.signatureDragHandleColor,
      cornerColor: this.signatureDragHandleColor,
      selectable: false, // disable selection
      hasControls: false, // disable control handles
      hasBorders: false, // disable borders
      hoverCursor: 'default',
      centeredScaling: false
    })
    this.signatureVerificationImg.scaleToHeight(this.defaultCanvasHeight)

    this.initPreview()
  },
  methods: {
    getBackendColorObject(colorhex) {
      const fcolor = new fabric.Color(colorhex)
      const rgb = fcolor.getSource()
      return { red: rgb[0], green: rgb[1], blue: rgb[2] }
    },
    getHexColorFromBackendColor(colorObject) {
      return '#' + ((1 << 24) + (colorObject.red << 16) + (colorObject.green << 8) + colorObject.blue).toString(16).slice(1)
    },
    loadSignatureImageFromFile(event) {
      const file = event
      if (!(file.size > this.biggestSignatureImageSize)) {
        const reader = new FileReader()
        reader.onload = (event) => this.setSignatureImage(file, event.target.result)
        reader.readAsDataURL(file)
      } else {
        showToastError(this.$t('toastMessage.selectedFileIsTooLarge'))
      }
    },
    calculateImageAspectRatioFit(img) {
      this.fcanvas.originX = 'left'
      this.fcanvas.originY = 'top'
      this.fcanvas.centeredScaling = false

      if (this.signerImageVisible) {
        this.signatureImg = new fabric.Image(img, {
          left: 0,
          top: 0,
          originX: 'left',
          originY: 'top',
          transparentCorners: false,
          borderColor: this.signatureDragHandleColor,
          cornerColor: this.signatureDragHandleColor,
          selectable: false, // disable selection
          hasControls: false, // disable control handles
          hasBorders: false, // disable borders
          hoverCursor: 'default',
          centeredScaling: false
        })
      }

      // this.signatureImg.setControlsVisibility(this.anottationControls)

      let simageHeight = 0
      if (this.signerImageVisible) {
        simageHeight = this.signatureImg.getScaledHeight()
      }

      if (this.signerImageVisible) {
        this.fcanvas.add(this.signatureImg)
      }

      if (this.signerImageVisible) {
        this.signatureImg.scaleToWidth(this.paddedWidth)
        if (this.signatureImg.getScaledHeight() > this.paddedHeight) {
          this.signatureImg.scaleToHeight(this.paddedHeight)
        }

        this.signatureImg.setCoords()

        // Position the object in the center of the padded area
        this.signatureImg.left = this.paddingX + (this.paddedWidth - this.signatureImg.getScaledWidth()) / 2
        this.signatureImg.top = this.paddingY + (this.paddedHeight - this.signatureImg.getScaledHeight()) / 2

        this.signatureImg.setCoords()
      }

      this.fcanvas.renderAll()

      // console.table(this.imageWidth, this.imageHeight, ratio)
    },
    handleBackgrounColor() {
      if (this.useBackgroundColor) {
        this.fcanvas.backgroundColor = this.backgroundColor
      } else {
        this.fcanvas.backgroundColor = 'transparent'
      }
    },
    initPreview(reloadImg = true) {
      this.updatingObjects = true
      try {
        if (this.fcanvas) {
          this.fcanvas.remove(...this.fcanvas.getObjects())
          this.fcanvas.clear()
          this.fcanvas.dispose()
          this.fcanvas = null
          this.signatureImg = null
        }

        if (!this.fcanvas) {
          this.fcanvas = new fabric.Canvas('preview', {
            selection: false
          })
        }
        this.fcanvas.setWidth(this.defaultCanvasWidth)
        this.fcanvas.setHeight(this.defaultCanvasHeight)

        this.leftBlockWidth = this.fcanvas.width / 2
        // Calculate the padding (10% of the left half width and canvas height)
        this.paddingX = this.leftBlockWidth * this.paddingPercent
        this.paddingY = this.fcanvas.height * this.paddingPercent

        this.paddedWidth = this.leftBlockWidth - (2 * this.paddingX)
        this.paddedHeight = this.fcanvas.height - (2 * this.paddingY)

        if (this.backgroundImageUrl) {
          this.backgroundImg = new Image()
          this.backgroundImg.src = this.backgroundImageUrl
          this.backgroundImg.decode().then(() => {
            // this.calculateImageAspectRatioFit(this.img)
            const fImg = new fabric.Image(this.backgroundImg)
            // this.fcanvas.setBackgroundImage(f_img)
            this.fcanvas.setBackgroundImage(fImg, this.fcanvas.renderAll.bind(this.fcanvas), {
              scaleX: this.fcanvas.width / this.backgroundImg.width,
              scaleY: this.fcanvas.height / this.backgroundImg.height
            })
            this.fcanvas.renderAll()
          })
        }

        this.handleBackgrounColor()

        this.signatureVerificationImg.scaleToHeight(this.fcanvas.height)
        this.fcanvas.add(this.signatureVerificationImg)

        /* if (this.signatureImageUrl) {
          this.sourceImageDataUrl = this.signatureImageUrl
        } else {
          this.sourceImageDataUrl = ''
        } */

        if (!reloadImg && this.img == null) {
          reloadImg = true
        }
        if (reloadImg) {
          if (this.signatureImageUrl) {
            this.signerImageVisible = true
            this.getImageDimensions(this.signatureImageUrl)
            this.aspectRatio = true
          } else {
            this.aspectRatio = false
            this.signerImageVisible = false
            this.imageWidth = this.defaultCanvasWidth
            this.imageHeight = this.defaultTextHeight
          }
        } else {
          if (this.signatureImageUrl) {
            this.signerImageVisible = true
          }
          if (this.signatureImageUrl) {
            this.calculateImageAspectRatioFit(this.img)
          }
        }

        if (this.signerTextVisible && !this.signerImageVisible) {
          this.calculateImageAspectRatioFit(null)
        }
      } finally {
        this.updatingObjects = false
      }
    },

    setSignatureImage(file, imageDataUri, callPreview = true) {
      const updatedDataUri = ''
      const splittedSigImgDataUrl = imageDataUri.split(';')
      this.sourceImageDataUrl = updatedDataUri.concat(splittedSigImgDataUrl[0], ';filename=' + file.name + ';', splittedSigImgDataUrl[1])
      if (callPreview) {
        this.initPreview()
      }
    },
    handleDragDrop(e) {
      this.backgroundImageUrl = e
      if (!e || e.length === 0) {
        this.backgroundImageUrl = null
      }
      this.initPreview()
    },
    handleBackroundValueChange() {
      if (!this.fcanvas) {
        this.initPreview()
      }
      if (this.fcanvas) {
        this.handleBackgrounColor()

        this.fcanvas.renderAll()
      }
    },
    getImageDimensions(imageDataUrl) {
      this.img = new Image()
      this.img.src = imageDataUrl
      this.img.decode().then(() => {
        this.imageNativeWidth = this.img.naturalWidth
        this.imageNativeHeight = this.img.naturalHeight
        this.calculateImageAspectRatioFit(this.img)
      })
    },
    async getVerificationImageDimensions(imageDataUrl) {
      this.verificationImg = new Image()
      this.verificationImg.src = imageDataUrl
      await this.verificationImg.decode()
      this.verificationImgNativeWidth = this.verificationImg.naturalWidth
      this.verificationImgNativeHeight = this.verificationImg.naturalHeight
    },

    async save() {
      // const dynamicBgImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='
      const req = {
        bgImageDataUrl: this.backgroundImageUrl ? this.backgroundImageUrl : undefined,
        // bgColor: this.useBackgroundColor ? this.getBackendColorObject(this.backgroundColor) : undefined
        bgColor: this.useBackgroundColor ? this.backgroundColor : undefined
      }
      try {
        await signatures.setVisisigAdminProps(req)
        showToastSuccess(this.$t('toastMessage.succesfullyUpdated'))
      } catch (error) {
        showToastError('toastMessage.errorWhileRetrievingData')
      }
    }
  }

}
</script>
